import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { FundraisingSummaryResponseNormalized } from '../../../../../../store/home/capture/types';

import { FutureMaturitiesItemDesktop } from './Desktop';
import { FutureMaturitiesItemMobile } from './Mobile';

export namespace FutureMaturitiesItemTypes {
  export type Props = {
    item: FundraisingSummaryResponseNormalized;
    onSelectAccount: (accountNumber: number) => void;
  };
}

export const FutureMaturitiesItem: React.FC<FutureMaturitiesItemTypes.Props> = (props) => {
  return useBreakpointValue({
    base: <FutureMaturitiesItemMobile {...props} />,
    sm: <FutureMaturitiesItemDesktop {...props} />,
  });
};
